<div class="share-delete">
    <sync-dialog
      [config]="{
        title: 'Remove user from shared folder',
        actionButton: 'Remove', 
        cancelButton: 'Cancel',
        subTitle: name,
        isClosable: false,
        onCancelClick: closeDialog,
        onActionClick: removeSelectedMembers,
        isButtonLoading: spinner,
      }"
       [isCritical]="true"
      [open]="showDialog"
      [isFullScreen]="isSmallScreen"
    >
    <!-- Show this section if user hasn't accepted the invite -->
    <div class="share-delete-waiting-wrapper" *ngIf="removeMembers[0]?.status === 'Waiting' || removeMembers[0]?.status === 'Waiting Signup'">
      <p class="body-1 text-wrapper">
        <span class="body-bold-1">{{email}}</span> hasn’t accepted your invite yet. Removing them will cancel the invite, and
        they won’t be able to join this folder.
      </p>
    </div>
    
    <!-- Show this section if user has accepted the invite -->
    <div class="share-delete-wrapper" *ngIf="!(removeMembers[0]?.status === 'Waiting' || removeMembers[0]?.status === 'Waiting Signup')">
          <p class="body-1 text-wrapper">If you remove <span class="body-bold-1">{{email}}</span>, they won't be able to see future changes to this shared folder.</p>
          <sync-divider [text]="'Content'" [size]="'default'"></sync-divider>
          <p class="body-bold-1 text-wrapper">Would you like this user to keep a copy of this folder?</p>
        <div class="check-box">
          <sync-radio-button-group class="radio-buttons" [radioButtonItems]="options" [changeRadioButtonValue]="selectedChange" />
        </div>
    </div>
    </sync-dialog>
  </div>